module.exports = __webpack_public_path__ + "img/ninja.cf49bed3.png";